import { Unview, View } from "../../../constants/images-constants";


export const UnviewIcon = (props) => {
  return <img src={Unview} onClick={props.onClick} alt="IMSA" />;
};
export const ViewIcon = (props) => {
  return <img src={View} onClick={props.onClick} alt="IMSA" />;
};
